import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import mixpanel from 'mixpanel-browser'
import { MIXPANEL_TOKEN, APP_ENV } from '@/lib/env'
import { useAuthStore } from '@/stores/auth'
import { useTeamStore } from '@/stores/team'

let initialized = false

function init() {
  if (initialized || !MIXPANEL_TOKEN) return
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: APP_ENV !== 'production',
    track_pageview: true,
    persistence: 'localStorage',
  })
  initialized = true
}

export function useMixpanelIdentify() {
  const profile = useAuthStore((s) => s.profile)
  const team = useTeamStore((s) => s.team)
  const identified = useRef(false)

  useEffect(() => {
    if (!MIXPANEL_TOKEN) return
    init()

    if (profile?.id && !identified.current) {
      mixpanel.identify(profile.id)
      mixpanel.people.set({
        $name: [profile.firstName, profile.lastName].filter(Boolean).join(' '),
        $email: profile.email ?? undefined,
        teamId: team?.id,
        teamName: team?.name,
      })
      identified.current = true
    }
  }, [profile, team])
}

export function useMixpanelPageTrack() {
  const location = useLocation()

  useEffect(() => {
    if (!MIXPANEL_TOKEN || !initialized) return
    mixpanel.track('Page View', { path: location.pathname })
  }, [location.pathname])
}

export function trackEvent(name: string, properties?: Record<string, unknown>) {
  if (!MIXPANEL_TOKEN || !initialized) return
  mixpanel.track(name, properties)
}

export function resetMixpanel() {
  if (!MIXPANEL_TOKEN || !initialized) return
  mixpanel.reset()
}
